import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService, ResponseType } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { GetAccessResponse, GetCustomerNamesAccessResponse, GetCustomerNamesForDocumentsAccessRequest, GetDocumentAccessRequest, GetFormAccessRequest, GiveDocumentAccessRequest, GiveFormAccessRequest, SaveDocumentAccessRequest} from "../models/document-management.models";

@autoinject
export class DocumentAccessApi {

    public documenAccessApi: string = `${this.configService.config.urls.documentManagementApiUrl}/api/v1/DocumentAccess`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }
    
    //Request document access
    public requestDocumentAccess(request : GetDocumentAccessRequest): Promise<any> {
        return this.requestClientService.post(`${this.documenAccessApi}/RequestDocumentAccess`, {}, request);
    }
    
    //Request form access
    public requestFormAccess(request : GetFormAccessRequest): Promise<any> {
        return this.requestClientService.post(`${this.documenAccessApi}/RequestFormAccess`, {}, request);
    }
    
    //Give form access
    public giveFormAccess(request: GiveFormAccessRequest): Promise<any> {
        return this.requestClientService.post(`${this.documenAccessApi}/GiveFormAccess`,{}, request);
    }

    //Give document Access
    public giveDocumentAccess(request: GiveDocumentAccessRequest): Promise<any> {
        return this.requestClientService.post(`${this.documenAccessApi}/GiveDocumentAccess`,{}, request);
    }

    //Get Customer Names For Documents Access
    public getCustomerNamesForDocumentsAccess(request: GetCustomerNamesForDocumentsAccessRequest): Promise<GetCustomerNamesAccessResponse[]> {
        return this.requestClientService.get(`${this.documenAccessApi}/GetCustomerNamesForDocumentsAccess`, request);
    }

    //Get document Access
    public getDocumentAccess(request: GetDocumentAccessRequest): Promise<GetAccessResponse> {
        return this.requestClientService.get(`${this.documenAccessApi}/GetDocumentAccess`, request);
    }

    //Save document Access
    public saveDocumentAccess(request: SaveDocumentAccessRequest): Promise<GetAccessResponse> {
        return this.requestClientService.post(`${this.documenAccessApi}/SaveDocumentAccess`, {}, request);
    }
}